import { credentialsSignUp } from '@/api/Auth';
import { SignUpPayload, SignUpResponse } from '@/types/auth';
import { useMutation } from '@tanstack/react-query';
import { useToastNotification } from '@treyd-io/treyd-ui/hooks/useToastNotification';
import { AxiosError, AxiosResponse } from 'axios';

export const useCredentialsSignup = () => {
  const notification = useToastNotification();
  return useMutation<
    AxiosResponse<SignUpResponse>,
    AxiosError<SignUpPayload>,
    SignUpPayload
  >({
    mutationFn: credentialsSignUp,
    onError: (error) => {
      error.response?.data?.non_field_errors &&
        notification({
          title: error.response.data.non_field_errors.join(),
          type: 'error',
        });
    },
  });
};
